/** Public app domain (e.g. "inboundhost.com" or "test.mergedev.com"), set at build time. */
export const APP_DOMAIN = (import.meta.env.VITE_APP_DOMAIN ?? 'inboundhost.com')
  .replace(/^https?:\/\//, '')
  .replace(/\/$/, '');

/** Build the public live URL for a site subdomain. */
export function siteLiveUrl(subdomain: string): string {
  return `https://${subdomain}.${APP_DOMAIN}`;
}
